import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "playback-controls" }
const _hoisted_2 = { class: "mode-indicator" }
const _hoisted_3 = { class: "mode-badge" }
const _hoisted_4 = { class: "control-button-container" }
const _hoisted_5 = { class: "control-icon" }
const _hoisted_6 = { class: "status-text" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }

import { computed } from 'vue';
import IconButton from '@/components/UI/IconButton.vue';
import type { GameMode } from '@/types/spotify';

interface Props {
  mode: GameMode;
  isPlaying: boolean;
  canPlay: boolean;
  hasUserPressedPlayButton: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PlaybackControls',
  props: {
    mode: {},
    isPlaying: { type: Boolean },
    canPlay: { type: Boolean },
    hasUserPressedPlayButton: { type: Boolean }
  },
  emits: ["play", "pause"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const modeText = computed(() => {
  switch (props.mode) {
    case 'premium':
      return '🎵 Spotify Premium';
    case 'preview':
      return '🔊 30 Sek. Vorschau';
    default:
      return '❌ Kein Modus';
  }
});

function handlePlayPause() {
  console.log('[PlaybackControls] handlePlayPause aufgerufen');
  console.log('[PlaybackControls] props.isPlaying =', props.isPlaying);

  if (props.isPlaying) {
    console.log('[PlaybackControls] EMIT pause');
    emit('pause');
  } else {
    console.log('[PlaybackControls] EMIT play');
    emit('play');
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(modeText.value), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(IconButton, {
        size: "xl",
        variant: __props.isPlaying ? 'secondary' : 'primary',
        disabled: !__props.canPlay,
        onClick: handlePlayPause,
        "aria-label": __props.isPlaying ? 'Pause' : 'Play'
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_5, _toDisplayString(__props.isPlaying ? '⏸' : '▶'), 1)
        ]),
        _: 1
      }, 8, ["variant", "disabled", "aria-label"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (!__props.canPlay)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Scanne eine Karte um zu starten"))
        : (!__props.isPlaying && !__props.hasUserPressedPlayButton)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Drücke Play, um den Song zu starten "))
          : (__props.hasUserPressedPlayButton && !__props.isPlaying)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Drehe dein Handy mit dem Display nach unten... "))
            : (__props.isPlaying)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Song läuft! 🎵 "))
              : _createCommentVNode("", true)
    ])
  ]))
}
}

})